import Skeleton from 'components/SA/Skeleton'
import React from 'react'
import heroCarouselStyles from 'components/SA/Carousel/HeroCarousel/HeroCarousel.module.scss'

const HeaderSectionSkeleton = () => {
  return (
    <div className={heroCarouselStyles.heroSectionSkeletonWrapper}>
      <div className={heroCarouselStyles.subNavTilesSkeletonContainer}>
        <Skeleton width='100px' height='38px' />
        <Skeleton width='100px' height='38px' />
        <Skeleton width='100px' height='38px' />
        <Skeleton width='100px' height='38px' />
        <Skeleton width='100px' height='38px' />
        <Skeleton width='100px' height='38px' />
        <Skeleton width='100px' height='38px' />
      </div>
      <div className={heroCarouselStyles.heroCarouselSkeletonContainer}>
        <Skeleton width='100%' height='100%' />
      </div>
      <div className={heroCarouselStyles.headerSectionTitleSkeletonBox}>
        <Skeleton width='40%' height='48px' />
      </div>
    </div>
  )
}

export default HeaderSectionSkeleton
